import { render, staticRenderFns } from "./Compartilhamento.vue?vue&type=template&id=10faac47&scoped=true&lang=pug"
import script from "./Compartilhamento.vue?vue&type=script&lang=js"
export * from "./Compartilhamento.vue?vue&type=script&lang=js"
import style0 from "./Compartilhamento.styl?vue&type=style&index=0&id=10faac47&prod&lang=stylus&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10faac47",
  null
  
)

export default component.exports